'use client'

import { useEffect } from 'react'
import { trackExperiment } from '@/core/trackExperiment'
import { resolveForClient } from '@/helpers/resolveAll'

export function ExperimentsTracking() {
  useEffect(() => {
    resolveForClient().forEach((exp) => trackExperiment(exp))
  }, [])

  return null
}
